import fetch from "auth/FetchInterceptor";
const AccountService = {};
AccountService.modifyAccount = function (accountData) {
    return fetch({
        method: "PUT",
        url: "/adminSchool",
        data: accountData,
    });
};
export default AccountService;
